export default {
  provider: 'https://eth.nownodes.io/702bf817-454b-4ea6-a350-e49b34073d50',
  binance_provider: 'https://bsc-dataseed.binance.org/',
  matic_provider: 'https://matic.nownodes.io/702bf817-454b-4ea6-a350-e49b34073d50', //  'https://polygon-mainnet.blastapi.io/cd810f69-e113-40ad-a9b6-88f413a9618b'
  arbitrum_provider: 'https://arb1.arbitrum.io/rpc',
  xdai_provider: 'https://rpc.gnosischain.com',
  ftm_provider: 'https://rpc.ftm.tools',
  avax_provider: 'https://api.avax.network/ext/bc/C/rpc',
  movr_provider: 'https://rpc.moonriver.moonbeam.network',
  one_provider: 'https://api.harmony.one',
  ame_provider: 'https://node1.amechain.io',
  aurora_provider: 'https://mainnet.aurora.dev',
  phi_provider: 'https://rpc1.phi.network',
}
